import { PERSISTENT_ENVS } from '../util/constants';

const shoppersiteHosts = ['inmaroffers', 'inmarpromotions', 'mycalgarycoop', 'lan'];
if (!PERSISTENT_ENVS.includes(process.env.REACT_APP_ENV_NAME)) {
  shoppersiteHosts.push(process.env.REACT_APP_LOCALHOST);
}
const isHostedByInmar = shoppersiteHosts.find((shoppersiteHostname) =>
  window.location.hostname.includes(shoppersiteHostname)
);

function getCustomURLRetailerName() {
  const url = window.location.hostname.split('.com');
  const splitUrl = url[0].split('.');

  return splitUrl[splitUrl.length - 1];
}

const retailerName = isHostedByInmar
  ? window.location.hostname.split('.')[0]
  : getCustomURLRetailerName();

function configBackendUrl() {
  // Local development backend runs only on the developer's machine, so HTTP is acceptable here.
  // All non-local environments below use HTTPS for secure transport.
  let configEnv = `http://127.0.0.1:8000`;
  if (process.env.REACT_APP_ENV_NAME === 'PROD') {
    configEnv = `https://brandsite.dpn.inmar.com`;
  } else if (process.env.REACT_APP_ENV_NAME === 'INTEGRATION') {
    configEnv = `https://brandsite.test.dpn.inmar.com`;
  } else if (process.env.REACT_APP_ENV_NAME === 'QA') {
    configEnv = `https://brandsite.qa.dpn.inmar.com`;
  }
  return configEnv;
}
const configEnv = configBackendUrl();

const apiConfig = {
  appEnv: process.env.REACT_APP_ENV_NAME,
  debug: process.env.REACT_APP_DEBUG,
  configUrl: window.location.host,
  envUrl: configEnv,
  retailer: { retailerName },
  isLoading: true,
};

export default apiConfig;
